var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeamStarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 79,
    viewBox: "0 0 84 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M41.7448 0.740795C41.8004 0.318678 42.4112 0.318678 42.4668 0.740796L46.245 29.4235C46.2811 29.6981 46.5986 29.8334 46.8217 29.6693L70.9315 11.9376C71.2771 11.6834 71.7011 12.1316 71.4282 12.4626L52.7178 35.1549C52.5344 35.3773 52.67 35.7146 52.9563 35.7482L83.1335 39.2938C83.5623 39.3442 83.5623 39.9667 83.1335 40.0171L52.9563 43.5627C52.67 43.5964 52.5344 43.9336 52.7178 44.156L71.4282 66.8484C71.7011 67.1793 71.2771 67.6275 70.9315 67.3734L46.8217 49.6416C46.5986 49.4775 46.2811 49.6128 46.245 49.8874L42.4668 78.5701C42.4112 78.9923 41.8004 78.9923 41.7448 78.5701L37.9666 49.8874C37.9304 49.6128 37.613 49.4775 37.3898 49.6416L13.2801 67.3734C12.9345 67.6275 12.5105 67.1793 12.7833 66.8484L31.4937 44.156C31.6772 43.9336 31.5416 43.5964 31.2553 43.5627L1.0781 40.0171C0.649227 39.9667 0.649227 39.3442 1.0781 39.2938L31.2553 35.7482C31.5416 35.7146 31.6772 35.3773 31.4937 35.1549L12.7833 12.4626C12.5105 12.1316 12.9345 11.6834 13.2801 11.9376L37.3898 29.6693C37.613 29.8334 37.9304 29.6981 37.9666 29.4235L41.7448 0.740795Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeamStarBlue);
export default __webpack_public_path__ + "static/media/seam_star_blue.7de851df087e5bbfadc28007347536a7.svg";
export { ForwardRef as ReactComponent };